// ============================================
// Mobile Menu Module
// Handles mobile menu open/close/escape functionality
// ============================================

/**
 * Initialize mobile menu functionality
 * Handles toggle, close buttons, escape key, and scroll lock
 */
export function initMobileMenu() {
  const menuButtons = document.querySelectorAll('.js-menu-toggle');
  const mobileMenu = document.querySelector('.js-mobile-menu');
  const closeButtons = document.querySelectorAll('.js-menu-close');

  if (!mobileMenu) return;

  /**
   * Open the mobile menu
   */
  function openMenu() {
    mobileMenu.classList.add('is-open');
    mobileMenu.setAttribute('aria-hidden', 'false');
    menuButtons.forEach((btn) => btn.setAttribute('aria-expanded', 'true'));
    document.body.style.overflow = 'hidden';
  }

  /**
   * Close the mobile menu
   */
  function closeMenu() {
    mobileMenu.classList.remove('is-open');
    mobileMenu.setAttribute('aria-hidden', 'true');
    menuButtons.forEach((btn) => btn.setAttribute('aria-expanded', 'false'));
    document.body.style.overflow = '';
  }

  // Bind toggle buttons
  menuButtons.forEach((btn) => {
    btn.addEventListener('click', openMenu);
  });

  // Bind close buttons (overlay and X button)
  closeButtons.forEach((btn) => {
    btn.addEventListener('click', closeMenu);
  });

  // Close on escape key
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && mobileMenu.classList.contains('is-open')) {
      closeMenu();
    }
  });
}
